export default __webpack_public_path__ + "static/media/zero-touches-production.b7cb0878.svg";